import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      form: {
        id: "",
        flag: "",
        language: "",
        desc: ""
      },
      honorList: [],
      rules: {
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        desc: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas, i;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$refs.newPopover.open();

                _this.honorList = [];

                if (data) {
                  _this.form = {
                    id: data.id,
                    flag: data.flag,
                    language: data.language,
                    desc: data.desc
                  };
                  datas = JSON.parse(data.desc);

                  for (i in datas) {
                    _this.honorList.push({
                      time: i,
                      list: datas[i]
                    });
                  }
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addTime: function addTime() {
      this.honorList.push({
        time: "",
        list: [{
          content: "",
          time: ""
        }]
      });
    },
    addMonth: function addMonth(index) {
      this.honorList[index].list.push({
        content: "",
        time: ""
      });
    },
    clearData: function clearData(id) {
      this.honorList = [];
      var datas = JSON.parse(this.form.desc);

      for (var i in datas) {
        this.honorList.push({
          time: i,
          list: datas[i]
        });
      }

      this.form = {
        id: this.form.id,
        flag: this.form.flag,
        language: this.form.language,
        desc: this.form.desc
      };
      this.$refs.ruleForm.resetFields();
    },
    picUrl: function picUrl(e, index) {
      this.honorList[index].pic = e.toString();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          // let reqFn = this.form.id ? 'updWebDescriptions' : 'addWebDescriptions'
          var newData = {};

          _this2.honorList.forEach(function (item) {
            newData[item.time] = item.list;
          });

          var data = {
            id: _this2.form.id,
            flag: _this2.form.flag,
            language: _this2.form.language,
            desc: JSON.stringify(newData)
          };

          _this2.$api.updWebDescriptions(data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.$refs.newPopover.hide();

              _this2.$emit('change');
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};